export const AUTH_ERROR_CODE = {
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  SERVER_UNAVAILABLE: 'SERVER_UNAVAILABLE',
  TOKEN_NOT_RECEIVED: 'TOKEN_NOT_RECEIVED',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
} as const;

export type AuthErrorCode = (typeof AUTH_ERROR_CODE)[keyof typeof AUTH_ERROR_CODE];

export class AuthError extends Error {
  override readonly name = 'AuthError';

  constructor(
    public readonly code: AuthErrorCode,
    message?: string,
  ) {
    super(message ?? code);
  }
}
